import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/chiguaData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200 bg-background-50/90 backdrop-blur-md shadow-soft"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-megaphone-fill text-lg" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading text-xl font-black tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            吃瓜<span className="text-primary-500">反差</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`rounded-full px-3.5 py-2 text-sm font-medium whitespace-nowrap transition-colors hover:bg-background-200/70 ${
                scrolled ? "text-foreground-700 hover:text-primary-600" : "text-background-100 hover:bg-background-50/20"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#faq"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-notification-4-line" aria-hidden="true"></i>
            追更吃瓜
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            className={`flex h-10 w-10 items-center justify-center rounded-full md:hidden ${
              scrolled ? "text-foreground-800 hover:bg-background-200" : "text-background-50 hover:bg-background-50/20"
            }`}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-2xl`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}